"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var MenuS = _interopRequireWildcard(require("./MenuStyles"));
var _MenuItemsList = _interopRequireWildcard(require("./MenuItemsList"));
var _ToggleMenuItem = _interopRequireDefault(require("./ToggleMenuItem"));
var _LogoutMenuItem = _interopRequireDefault(require("./LogoutMenuItem"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
var propTypes = {
  /** Initial state for the menu */
  initialOpen: _propTypes["default"].bool,
  /** Styling props for the Menu Wrapper. They would get set for each project's menu when implementing the design. */
  wrapperProps: _propTypes["default"].object,
  /** A React component for the logo */
  logo: _propTypes["default"].any,
  /** An array of menu items */
  menuItems: _propTypes["default"].arrayOf(_propTypes["default"].shape(_MenuItemsList.menuItemShape)),
  /** The function that will be called when logout menu item. Should logout the current user. */
  logout: _propTypes["default"].func,
  /** The image source and description for white-labeling */
  whiteLabel: _propTypes["default"].shape({
    src: _propTypes["default"].string,
    alt: _propTypes["default"].string
  }),
  /** Styling props for the Menu WhiteLabel. They would get set for each project's menu when implementing the design. */
  whiteLabelProps: _propTypes["default"].object
};
exports.propTypes = propTypes;
var Menu = function Menu(_ref) {
  var _ref$initialOpen = _ref.initialOpen,
    initialOpen = _ref$initialOpen === void 0 ? false : _ref$initialOpen,
    wrapperProps = _ref.wrapperProps,
    logo = _ref.logo,
    menuItems = _ref.menuItems,
    logout = _ref.logout,
    whiteLabel = _ref.whiteLabel,
    whiteLabelProps = _ref.whiteLabelProps;
  var _useState = (0, _react.useState)(initialOpen),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  var toggleMenu = (0, _react.useCallback)(function () {
    setIsOpen(function (s) {
      return !s;
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement(MenuS.Wrapper, _extends({
    isOpen: isOpen
  }, wrapperProps), /*#__PURE__*/_react["default"].createElement(logo, {
    isOpen: isOpen,
    onClick: toggleMenu
  }), /*#__PURE__*/_react["default"].createElement(_MenuItemsList["default"], {
    menuItems: menuItems,
    isMenuOpen: isOpen,
    openMenu: function openMenu() {
      return setIsOpen(true);
    }
  }), /*#__PURE__*/_react["default"].createElement(_LogoutMenuItem["default"], {
    logout: logout
  }), /*#__PURE__*/_react["default"].createElement(MenuS.Footer, {
    onClick: toggleMenu
  }, /*#__PURE__*/_react["default"].createElement(_ToggleMenuItem["default"], {
    isOpen: isOpen
  })), /*#__PURE__*/_react["default"].createElement(MenuS.WhiteLabel, whiteLabelProps, /*#__PURE__*/_react["default"].createElement("img", {
    className: "test-logo",
    src: whiteLabel.src,
    alt: whiteLabel.alt
  })));
};
Menu.propTypes = propTypes;
var _default = Menu;
exports["default"] = _default;